import Modal from '@ui/Modal/component'

export default function (): void {
  const modalEl = document.getElementById('cart-recap-modal-reward')
  const alertEl = document.getElementById('cart-recap-alert-reward')

  if (!modalEl || !alertEl) {
    return
  }

  const modal = Modal(modalEl)

  alertEl.addEventListener('click', () => {
    modal.open()
  })
}
